import gsap from 'gsap'
import { SplitText } from 'gsap/SplitText'
import { ScrollTrigger } from 'gsap/all'

gsap.registerPlugin(SplitText, ScrollTrigger)

export default class TextAnimation {
	constructor() {
		this.containers = document.querySelectorAll('[data-text-animation]')

		if (!this.containers.length > 0) return

		this.tls = []
		this.debug = false

		this.#init()
	}

	#init() {
		this.containers.forEach(container => this.#setupScrollTrigger(container))
	}

	#setupScrollTrigger(container) {
		const textEls = this.#excludeItems(container)

		if (!textEls) return

		let tl = null

		SplitText.create(textEls, {
			type: 'lines',
			mask: 'lines',
			autoSplit: true,
			onSplit: item => {
				tl?.kill?.()
				tl = gsap
					.timeline({
						scrollTrigger: {
							trigger: container,
							start: 'top 65%',
							markers: this.debug,
							toggleActions: 'play resume resume reverse',
						},
					})
					.from(item.lines, {
						yPercent: 100,
						stagger: 0.05,
						ease: 'power2.inOut',
						duration: 0.5,
					})

				this.tls.push(tl)
			},
		})
	}

	#excludeItems(container) {
		const excludedSelectors = ['[data-service-card] *']

		const excluded = new Set(container.querySelectorAll('.block-content > p'))

		const textEls = Array.from(container.querySelectorAll('.block-content > *')).filter(el => {
			if (excludedSelectors.some(sel => el.matches(sel))) return false
			if (!excluded.has(el)) return true
			return !el.querySelector('.is-button')
		})

		return textEls
	}
}
